export const VOLUME_TRENDS_REPORT = 'Volume Trends Report';
export const VOLUME_TRENDS_REPORT_TITLE = 'VolumeTrendsReport';

export const columns = [
  { name: 'yearSelected', title: 'Year' },
  { name: 'day', title: 'Day', type: 'date' },
  { name: 'volume', title: 'Volume' },
  { name: 'measure', title: 'Measure' },
];